/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "WETH",
        outputs: [
            {
                internalType: "contract IWETH",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "chainId_",
                type: "uint16",
            },
        ],
        name: "bridgeContracts",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "isTransferCompleted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "isWrappedAsset",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "outstandingBridged",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseRegisterChain",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainID",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.RegisterChain",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "newContract",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.UpgradeContract",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "registerChain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "tokenChainId",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "tokenAddress",
                type: "bytes32",
            },
        ],
        name: "wrappedAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "attestToken",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "arbiterFee",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "wrapAndTransferETH",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "arbiterFee",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "transferTokens",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "updateWrapped",
        outputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "createWrapped",
        outputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransferAndUnwrapETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "decimals",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.AssetMeta",
                name: "meta",
                type: "tuple",
            },
        ],
        name: "encodeAssetMeta",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint256",
                        name: "fee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        name: "encodeTransfer",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseAssetMeta",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "decimals",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.AssetMeta",
                name: "meta",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseTransfer",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint256",
                        name: "fee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
var _bytecode = "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";
var Bridge__factory = /** @class */ (function (_super) {
    __extends(Bridge__factory, _super);
    function Bridge__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    Bridge__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    Bridge__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    Bridge__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Bridge__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Bridge__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    Bridge__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    Bridge__factory.bytecode = _bytecode;
    Bridge__factory.abi = _abi;
    return Bridge__factory;
}(ContractFactory));
export { Bridge__factory };
